// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet producten-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainDoelgroepEnum =
  (typeof SUREbusinessCommonDomainDoelgroepEnum)[keyof typeof SUREbusinessCommonDomainDoelgroepEnum];

export const SUREbusinessCommonDomainDoelgroepEnum = {
  MKB: 'MKB',
  VVE: 'VVE',
  OG: 'OG',
  ZZP: 'ZZP',
} as const;
